'use strict';
var parent = require('../../es/disposable-stack');

module.exports = parent;
